module.exports = __webpack_public_path__ + "static/img/connecta.2be0f6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connecta.jpg
// module id = pPln
// module chunks = 1